import { z } from 'zod';

import { AssignmentScheduleSchema } from './AssignmentScheduleSchema';

const GlobalSettingsSchema = z.object({
  timesheet_split_hours_across_calendar_days: z.boolean(),
  two_factor_authentication: z.boolean(),
  department_assignment_schedule: z.union([z.null(), AssignmentScheduleSchema]),
  plan_dates_department_check: z.boolean(),
  distance_balanced_assignment: z.boolean(),
  taskType_department_check: z.boolean(),
  person_shift_restrictions: z.object({
    maxMonthlyScheduledHours: z
      .union([
        z.number({
          invalid_type_error: 'Должно быть целым числом'
        }),
        z.null(),
        z.undefined()
      ])
      .refine((val) => val !== null && val !== undefined, {
        message: 'Необходимо ввести значение от 1 до 500'
      })
      .transform((val) => (val === null || val === undefined ? 0 : val))
      .pipe(
        z
          .number()
          .int('Должно быть целым числом')
          .min(1, 'Интервал допустимых значений от 1 до 500')
          .max(500, 'Интервал допустимых значений от 1 до 500')
      ),
    maxConsecutiveDaysWithShifts: z
      .union([
        z.number({
          invalid_type_error: 'Должно быть целым числом'
        }),
        z.null(),
        z.undefined()
      ])
      .refine((val) => val !== null && val !== undefined, {
        message: 'Необходимо ввести значение от 1 до 100'
      })
      .transform((val) => (val === null || val === undefined ? 0 : val))
      .pipe(
        z
          .number()
          .int('Должно быть целым числом')
          .min(1, 'Интервал допустимых значений от 1 до 100')
          .max(100, 'Интервал допустимых значений от 1 до 100')
      )
  })
});

export default GlobalSettingsSchema;
